import { Action } from 'redux';
import { Epic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import { concat as concat$ } from 'rxjs/observable/concat';
import { from as from$ } from 'rxjs/observable/from';
import {
    ACTION_GENDERS_LOAD,
    ACTION_GENDERS_LOAD_BY_ID,

    ACTION_GENDERS_SAVE,

    ACTION_GENDERS_CREATE,

    IGenderLoadAction,
    IGenderLoadByIdAction,
    IGenderLoadFailureAction,
    IGenderLoadSuccessAction,

    IGenderSaveAction,
    IGenderSaveSuccessAction,
    IGenderSaveFailureAction,

    IGenderCreateAction,
    IGenderCreateSuccessAction,
    IGenderCreateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

} from "../actions/genders";
import { gendersApi } from "../services/gender";


export const
    getGendersEpic = (action$): Observable<IGenderLoadSuccessAction | IGenderLoadFailureAction> => {
        return action$
            .ofType(ACTION_GENDERS_LOAD)
            .mergeMap((action: IGenderLoadAction) => {
                return gendersApi
                    .getGenders()
                    .map(response =>
                        LoadSuccess(response.genders, undefined, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getGenderByIdEpic = (action$): Observable<IGenderLoadSuccessAction | IGenderLoadFailureAction> => {
        return action$
            .ofType(ACTION_GENDERS_LOAD_BY_ID)
            .mergeMap((action: IGenderLoadByIdAction) => {
                return gendersApi
                    .getGenderById(action.id)
                    .map(response =>
                        LoadSuccess(response.gender, response.formState, response.formProperties, response.formRoles, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setGenderEpic = (action$): Observable<IGenderSaveSuccessAction | IGenderSaveFailureAction> => {
        return action$
            .ofType(ACTION_GENDERS_SAVE)
            .mergeMap((action: IGenderSaveAction) => {
                return gendersApi
                    .setGender(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.gender, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createGenderEpic = (action$): Observable<IGenderCreateSuccessAction | IGenderCreateFailureAction> => {
        return action$
            .ofType(ACTION_GENDERS_CREATE)
            .mergeMap((action: IGenderCreateAction) => {
                return gendersApi
                    .createGender()
                    .map(response =>
                        CreateSuccess(
                            response.gender,
                            response.formState,
                            response.formProperties,
                            response.formRoles,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    }



